import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ProblemsSection } from '../components/ProblemsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { OffersSection } from '../components/OffersSection';
import { FreeResourcesSection } from '../components/FreeResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FooterCTA } from '../components/FooterCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2364">
      <Header data-id="element-2365" />
      <main data-id="element-2366">
        <HeroSection data-id="element-2367" />
        <ProblemsSection data-id="element-2368" />
        <AboutSection data-id="element-2369" />
        <MethodSection data-id="element-2370" />
        <OffersSection data-id="element-2371" />
        <FreeResourcesSection data-id="element-2372" />
        <TestimonialsSection data-id="element-2373" />
        <FooterCTA data-id="element-2374" />
      </main>
      <Footer data-id="element-2375" />
    </div>;
}